import PropTypes from "prop-types";

import { progressBarCss, stepCss } from "./ProgressBar.style";

const progressBarPropTypes = {
  current: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  count: PropTypes.number,
};

const ProgressBarStep = ({ count, isComplete }) => {
  return <div css={stepCss(count, isComplete)} />;
};

const ProgressBar = ({ current, count }) => {
  const countValue = [];
  for (let i = 0; i < count; i++) {
    const isMarked = i < current;
    countValue.push(isMarked);
  }
  return (
    <div css={progressBarCss}>
      {countValue.map((val, index) => (
        <ProgressBarStep key={index} count={count} isComplete={val} />
      ))}
    </div>
  );
};

ProgressBar.propTypes = progressBarPropTypes;
export default ProgressBar;
